import React from 'react'
import { Form } from 'react-bootstrap'

import { Controller } from 'react-hook-form'
import MaskedInput from 'react-input-mask'

import * as libValidate from '@lib/validate'


const CpfComponent = ({
	control,
	disabled=false,
	errors,
	label=null,
	name,
	register,
	required=true,
	...rest
}) => {

	return (
		<>

			<Form.Group className='mb-3'>
				{label && 
					<Form.Label
						className='mb-0'
						htmlFor={name}
					>{label}</Form.Label>
				}

				<Controller 
					control={control}
					defaultValue=''
					{...register(name, {
						required: {
							value: required,
							message: 'Campo obrigatório'
						},
						validate: (disabled === false) ? value => libValidate['validateCPF'](value) : null
					})}
					render={({ field }) => (
						<MaskedInput
							disabled={disabled}
							id={name}
							mask='999.999.999-99'
							maskChar=''
							name={name}
							onChange={field.onChange}
							placeholder='000.000.000-00'
							value={field.value}
						>
							{(inputProps) => (
								<input
									{...inputProps}
									className='form-control'
									disabled={disabled}
									id={name}
									name={name}
									type='text'
									{...rest}
								/>
							)}
						</MaskedInput>
					)}
				/>

				{errors[name] && <p className='mt-1 form-error'>{errors[name].message}</p>}
			</Form.Group>

		</>
	)

}

export default CpfComponent;
